import React from 'react';

const SvgProfileUniversity = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.41 6.784l-8.7-2.675a2.5 2.5 0 00-1.463 0l-8.7 2.675a.737.737 0 000 1.425l1.513.463a2.451 2.451 0 00-.55 1.462.987.987 0 00-.513.863c0 .337.175.625.425.8l-.787 3.575a.5.5 0 00.487.612h1.75a.5.5 0 00.488-.612l-.8-3.575a1 1 0 00.437-.8.987.987 0 00-.5-.838c.025-.475.275-.887.65-1.15l6.1 1.875a2.5 2.5 0 001.463 0l8.7-2.675a.738.738 0 000-1.425zm-8.4 5.063a3.5 3.5 0 01-2.05 0l-4.525-1.4-.438 3.537c0 1.1 2.675 2 5.988 2 3.3 0 5.987-.9 5.987-2l-.437-3.537-4.538 1.387.013.013z" />
  </svg>
);

export default SvgProfileUniversity;
